import React from "react"
import { t } from "i18next"
import PropTypes from "prop-types"
import Skeleton from "./Skeleton"
import no_result_image from "../../assets/images/no-results.svg"
import server_error_image from "../../assets/images/server-error.svg"
import Result from "./Result"

function HandleError(props) {
  const { isLoading, error, isEmpty, renderError, renderEmpty, children } =
    props
  // check is loading
  if (isLoading) return <Skeleton />

  // check is error
  if (error) {
    return renderError ? (
      renderError
    ) : (
      <Result title={error} image={server_error_image} />
    )
  }
  // check is empty data
  if (isEmpty && !isLoading) {
    return renderEmpty ? (
      renderEmpty
    ) : (
      <Result title={t("not found results")} image={no_result_image} />
    )
  }

  return children
}
HandleError.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  error: PropTypes.any,
  renderError: PropTypes.node,
  renderEmpty: PropTypes.node,
  children: PropTypes.node,
}
export default HandleError
